export { default } from './ReceptionBanner';
